// import LandingComponent from '../components/LandingComponent';
import Logo from '../GCLOGO.png';
import React from 'react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { status } from '../hooks/AuthProvider';
import DownloadsNavLink from '../components/DownloadsNavLink';
import HeaderCTA from '../components/HeaderCTA';

type props = {};
type state = {
    loading: boolean;
    showingSolutions: boolean;
    isScrolled: boolean;
    isAuthenticated: boolean;
    isProductsOpen: boolean;
}

export class Header extends React.Component<props, state> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            showingSolutions: false,
            isScrolled: false,
            isAuthenticated: false,
            isProductsOpen: false

        }
    }

    async componentDidMount() {
        const handleScroll = () => {
            this.setState({isScrolled: window.scrollY > 10});
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }

    setShowing(showing: boolean) {
        this.setState({showingSolutions: showing});
    }

    render() {
        return <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                this.state.isScrolled ? "bg-black/80 backdrop-blur-sm" : "bg-transparent"
            }`}
        >
            <div className="container mx-auto px-4">
                <div className="flex h-16 items-center justify-between">
                    <a href="/" className="flex items-center space-x-2 transition-opacity hover:opacity-80">
                        <img src={Logo} width={'200'} />
                        {/* <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                        </svg>
                        <span className="text-xl font-bold">GuardedContent</span> */}
                    </a>

                    {/* New middle section with dropdowns */}
                    <nav className="hidden md:flex items-center space-x-6">
                        <div className="relative">
                            <Popover
                                onMouseEnter={() => this.setShowing(true)}
                                onMouseLeave={() => this.setShowing(false)}
                            >
                                <PopoverButton className="text-white hover:text-red-500 transition-colors flex items-center">Solutions</PopoverButton>
                                <Transition
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                    show={this.state.showingSolutions}
                                >
                                    <PopoverPanel
                                    anchor="bottom"
                                    className={`divide-y divide-white/5 rounded-xl bg-black/80 backdrop-blur-sm text-sm/6 [--anchor-gap:var(--spacing-5)] mt-2`}
                                    >
                                    <div className="p-3">
                                        <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="./#features">
                                            <p className="font-semibold text-white">General Media</p>
                                            <p className="text-white/50">Protect your content using DRM</p>
                                        </a>
                                        {/* <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                            <p className="font-semibold text-white">Music</p>
                                            <p className="text-white/50">Protect your music using DRM</p>
                                        </a>
                                        <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                            <p className="font-semibold text-white">Corporate Documents</p>
                                            <p className="text-white/50">Protect your documents using DRM</p>
                                        </a> */}
                                    </div>
                                    {/* <div className="p-3">
                                        <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                        <p className="font-semibold text-white">Documentation</p>
                                        <p className="text-white/50">Start integrating products and tools</p>
                                        </a>
                                    </div> */}
                                    </PopoverPanel>
                                </Transition>
                            </Popover>
                            {/* <button
                                // onClick={() => this.setIsProductsOpen(!this.state.isProductsOpen)}
                                onClick={() => this.setState({ isProductsOpen: !this.state.isProductsOpen })}
                                className="text-white hover:text-red-500 transition-colors flex items-center"
                            >
                                Products
                                <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button> */}
                        {/* {this.state.isProductsOpen && (
                            <div className="absolute top-full left-0 mt-2 w-56 bg-gray-900 border border-gray-800 rounded-md shadow-lg">
                                <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Content Creation Suite</a>
                                <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Analytics Dashboard</a>
                                <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Collaboration Tools</a>
                            </div>
                        )} */}
                        </div>
                        {/* <a href="/pricing" className="text-white hover:text-red-500 transition-colors">Pricing</a> */}
                        <DownloadsNavLink />
                    </nav>

                    <nav className="flex items-center gap-4">
                        <HeaderCTA />
                    </nav>
                </div>
            </div>
        </header>
    }
}


export default function Terms() {
    return <>
        <Header />
        <div className="p-20">
            <h2 className="text-6xl text-center">
                <strong>GuardedContent Terms and Conditions</strong>
            </h2>
            <p className="text-center mt-4">Last Updated: 23/02/2026</p>
            <p className="text-center">Effective Date: 23/02/2026</p>
            <br />
            <p>These Terms and Conditions (&quot;Terms&quot;) govern your access to and use of the GuardedContent platform (&quot;Platform&quot;), operated by GuardedContent Pty Ltd (ABN 46 688 024 535) (&quot;GuardedContent&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;), a company registered in New South Wales, Australia.</p>
            <br />
            <p>By accessing or using the Platform, you agree to be legally bound by these Terms. If you do not agree, you must not access or use the Platform.</p>

            <br /><h3 className="text-4xl">1. Definitions</h3><br />
            <ul className="list-disc list-inside">
                <li><span className="font-bold">Platform</span> means the GuardedContent website, applications, APIs, and related services.</li>
                <li><span className="font-bold">User</span> means any individual who accesses or uses the Platform.</li>
                <li><span className="font-bold">Content Creator</span> means a User who uploads, distributes, or monetises Content on the Platform.</li>
                <li><span className="font-bold">Content</span> means any digital media including videos, livestreams, audio, images, text, or other materials uploaded by Content Creators or provided by licensed rights holders.</li>
                <li><span className="font-bold">Purchase</span> means a one-time payment granting a limited licence to view specific Content.</li>
                <li><span className="font-bold">Subscription</span> means a recurring payment granting ongoing access to a Content Creator&apos;s Content.</li>
                <li><span className="font-bold">DRM Technology</span> means encryption, watermarking, access-control, and anti-piracy technologies used to protect Content.</li>
                <li><span className="font-bold">Licence</span> means a limited, revocable, non-transferable right to stream Content; it does not transfer ownership of the Content.</li>
                <li><span className="font-bold">Platform Fee</span> means the commission charged by GuardedContent on transactions between Users and Content Creators.</li>
            </ul>

            <br /><h3 className="text-4xl">2. Role of the Platform</h3><br />
            <div className="px-4">
                <h4 className="text-3xl font-semibold">2.1</h4>
                <p>GuardedContent operates as an online platform that facilitates access to digital Content made available by Content Creators and other rights holders.</p>
                <br />
                <h4 className="text-3xl font-semibold">2.2</h4>
                <p>In most cases, GuardedContent acts as an intermediary marketplace that enables transactions between Users and Content Creators. Content Creators are the suppliers and licensors of the Content they upload to the Platform.</p>
                <br />
                <h4 className="text-3xl font-semibold">2.3</h4>
                <p>GuardedContent provides the technical infrastructure required to host, protect, and stream Content, including:</p>
                <ul className="list-disc list-inside ml-4">
                    <li>Secure hosting and storage services</li>
                    <li>DRM protection and encrypted streaming delivery</li>
                    <li>Payment processing integration</li>
                    <li>Subscription and purchase management tools</li>
                </ul>
                <br />
                <h4 className="text-3xl font-semibold">2.4</h4>
                <p>GuardedContent does not acquire ownership of Content uploaded by Content Creators unless expressly agreed in a separate written agreement.</p>
                <br />
                <h4 className="text-3xl font-semibold">2.5</h4>
                <p>In some cases, GuardedContent may act as a licensed distributor of premium or exclusive Content under separate agreements with rights holders, including but not limited to concerts, festivals, or label-owned media. In such cases, GuardedContent may control pricing, availability, geographic access, licensing windows, and other distribution terms applicable to that Content.</p>
                <br />
                <h4 className="text-3xl font-semibold">2.6</h4>
                <p>Content availability may vary depending on licensing rights, geographic restrictions, contractual obligations, and technical requirements. GuardedContent reserves the right to modify, restrict, or discontinue access to any Content where required by law, contractual licensing terms, or operational considerations.</p>
                <br />
                <h4 className="text-3xl font-semibold">2.7</h4>
                <p>GuardedContent is not responsible for independently verifying ownership, licensing rights, or legality of Content provided by Content Creators and relies on the representations and warranties provided by those Content Creators under separate agreements or applicable law.</p>
            </div>

            <br /><h3 className="text-4xl">3. User Accounts</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>3.1</strong> You must create an account to access certain features of the Platform.</li>
                <li><strong>3.2</strong> You must be at least 18 years old to use paid features of the Platform.</li>
                <li><strong>3.3</strong> You are responsible for maintaining the confidentiality of your login credentials.</li>
                <li><strong>3.4</strong> You must not share, resell, or transfer your account credentials to any third party.</li>
                <li><strong>3.5</strong> You are responsible for all activity that occurs under your account.</li>
            </ul>
            <p className="mt-4"><strong>3.6</strong> GuardedContent may monitor concurrent sessions, device identifiers, IP addresses, and usage patterns to detect and prevent account sharing, credential abuse, or fraudulent access.</p>
            <p className="mt-4">GuardedContent may suspend or terminate accounts involved in:</p>
            <ul className="list-disc list-inside ml-4 mt-2">
                <li>Account sharing or credential resale</li>
                <li>Concurrent session abuse</li>
                <li>Attempts to bypass DRM or access restrictions</li>
            </ul>

            <br /><h3 className="text-4xl">4. Nature of Purchases and Access Rights</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>4.1</strong> When you purchase or subscribe to Content, you are granted a limited Licence to stream the Content for personal, non-commercial use only.</li>
                <li><strong>4.2</strong> You do not obtain ownership rights in the Content.</li>
                <li><strong>4.3</strong> Licences are:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>Non-transferable</li>
                <li>Revocable</li>
                <li>Subject to DRM and platform restrictions</li>
            </ul>
            <p className="mt-4"><strong>4.4</strong> Access to Content may be restricted based on:</p>
            <ul className="list-disc list-inside ml-4 mt-2">
                <li>Device or operating system</li>
                <li>Geographic licensing rights</li>
                <li>Concurrent stream limits</li>
                <li>Required playback technologies</li>
            </ul>
            <ul className="list-disc list-inside mt-4">
                <li><strong>4.5</strong> The Platform provides streaming-only access to Content. Offline downloads, permanent copies, or local storage of Content are not provided or guaranteed.</li>
                <li><strong>4.6</strong> Access to Content is contingent on continued availability of the Platform, the User&apos;s account standing, and applicable technical or licensing restrictions.</li>
            </ul>

            <br /><h3 className="text-4xl">5. Payments and Billing</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>5.1</strong> Payments are processed through third-party payment providers (including Stripe). GuardedContent is not a payment processor and is not responsible for errors, outages, or actions of payment providers.</li>
                <li><strong>5.2</strong> By making a Purchase or Subscription, you agree to the payment provider&apos;s terms and policies.</li>
                <li><strong>5.3</strong> Subscriptions automatically renew unless cancelled prior to the renewal date.</li>
                <li><strong>5.4</strong> Prices displayed on the Platform may include applicable taxes (including GST or VAT) depending on the customer&apos;s location and applicable law.</li>
                <li><strong>5.5</strong> GuardedContent may:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>Deduct Platform Fees and payment processing costs</li>
                <li>Withhold payouts during fraud or dispute investigations</li>
                <li>Offset refunds or chargebacks against creator balances</li>
            </ul>

            <br /><h3 className="text-4xl">6. Refunds and Chargebacks</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>6.1</strong> Purchases and Subscriptions are generally non-refundable except where required by applicable consumer protection laws, including the Australian Consumer Law.</li>
                <li><strong>6.2</strong> GuardedContent may, at its discretion, issue refunds where:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>Content is removed due to legal or rights issues</li>
                <li>Access cannot be provided due to technical failure</li>
                <li>Required by law</li>
            </ul>
            <ul className="list-disc list-inside mt-4">
                <li><strong>6.3</strong> Where refunds are issued, GuardedContent may recover the refunded amount from the relevant Content Creator.</li>
                <li><strong>6.4</strong> Users must not initiate fraudulent chargebacks. Abuse of chargebacks may result in account suspension or termination.</li>
            </ul>

            <br /><h3 className="text-4xl">7. Content Ownership and Platform Licence</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>7.1</strong> Content Creators retain all intellectual property rights in the Content they upload.</li>
                <li><strong>7.2</strong> To enable operation of the Platform, Content Creators grant GuardedContent a limited, non-exclusive, worldwide, royalty-free licence to:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>host and store Content;</li>
                <li>encode, transcode, and package Content for streaming;</li>
                <li>encrypt and protect Content using DRM Technology;</li>
                <li>stream and distribute Content to authorised Users via the Platform.</li>
            </ul>
            <ul className="list-disc list-inside mt-4">
                <li><strong>7.3</strong> This operational licence exists solely for the purpose of providing hosting, protection, and streaming services through the Platform.</li>
                <li><strong>7.4</strong> The commercial terms governing distribution, monetisation, territory, exclusivity, revenue share, and removal rights between GuardedContent and a Content Creator are governed separately by the applicable Content Leasing Agreement or Creator Agreement entered into between the parties.</li>
                <li><strong>7.5</strong> In the event of any inconsistency between these Terms and a signed Content Leasing Agreement, the Content Leasing Agreement will prevail to the extent of the inconsistency.</li>
            </ul>

            <br /><h3 className="text-4xl">8. Creator Responsibilities and Warranties</h3><br />
            <p>Content Creators represent and warrant that:</p>
            <ul className="list-disc list-inside ml-4 mt-2">
                <li>They own or hold valid licences for all uploaded Content</li>
                <li>They have the legal right to distribute and monetise the Content</li>
                <li>The Content does not infringe any third-party intellectual property rights</li>
                <li>The Content complies with all applicable laws and contractual obligations</li>
            </ul>
            <p className="mt-4">Content Creators agree to indemnify GuardedContent against claims arising from their Content.</p>

            <br /><h3 className="text-4xl">9. Digital Rights Management (DRM)</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>9.1</strong> The Platform uses DRM Technology to protect Content from unauthorised copying and redistribution.</li>
                <li><strong>9.2</strong> Content may include forensic watermarking or other tracking technologies to identify unauthorised redistribution.</li>
                <li><strong>9.3</strong> Users must not:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>Circumvent or attempt to bypass DRM protections</li>
                <li>Record, copy, download, redistribute, or publicly perform Content</li>
                <li>Reverse engineer encryption or playback systems</li>
            </ul>
            <p className="mt-4"><strong>9.4</strong> Violations may result in:</p>
            <ul className="list-disc list-inside ml-4 mt-2">
                <li>Immediate suspension or termination of access</li>
                <li>Revocation of licences</li>
                <li>Legal action where applicable</li>
            </ul>
            <p className="mt-4">While GuardedContent employs robust DRM and watermarking measures, it cannot guarantee that Content will never be copied by third parties.</p>

            <br /><h3 className="text-4xl">10. Platform Availability</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>10.1</strong> GuardedContent does not guarantee uninterrupted or error-free access to the Platform or Content.</li>
                <li><strong>10.2</strong> Streaming performance may be affected by network conditions, device compatibility, geographic restrictions, or third-party service outages.</li>
                <li><strong>10.3</strong> GuardedContent may modify, suspend, or discontinue features of the Platform at any time without liability.</li>
                <li><strong>10.4</strong> GuardedContent is not liable for delays or failures caused by events beyond its reasonable control, including network outages, cloud infrastructure failures, or third-party service disruptions.</li>
            </ul>

            <br /><h3 className="text-4xl">11. Prohibited Conduct</h3><br />
            <p>Users must not:</p>
            <ul className="list-disc list-inside ml-4 mt-2">
                <li>Upload infringing, unlawful, or misleading Content</li>
                <li>Harass or abuse other users or creators</li>
                <li>Attempt to hack, disrupt, or overload the Platform</li>
                <li>Use automated scraping, piracy, or capture tools</li>
                <li>Share or resell account access</li>
            </ul>
            <p className="mt-4">GuardedContent may remove Content or suspend accounts that violate these rules.</p>

            <br /><h3 className="text-4xl">12. Content Removal</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>12.1</strong> Content Creators may remove their Content subject to any applicable Content Leasing Agreement.</li>
                <li><strong>12.2</strong> Users will generally retain access to purchased Content unless:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>The Content is removed for legal or rights-related reasons</li>
                <li>The Creator&apos;s account is terminated</li>
                <li>A refund is issued</li>
            </ul>
            <ul className="list-disc list-inside mt-4">
                <li><strong>12.3</strong> GuardedContent may remove Content that violates laws, contractual obligations, or platform policies.</li>
            </ul>

            <br /><h3 className="text-4xl">13. Termination</h3><br />
            <ul className="list-disc list-inside">
                <li><strong>13.1</strong> GuardedContent may suspend or terminate accounts at its sole discretion for violations of these Terms.</li>
                <li><strong>13.2</strong> Upon termination:</li>
            </ul>
            <ul className="list-disc list-inside ml-8 mt-2">
                <li>All licences to Content immediately cease</li>
                <li>Access to purchased or subscribed Content may be revoked</li>
                <li>Outstanding balances may be withheld pending investigation</li>
            </ul>
            <p className="mt-4">Provisions relating to payments, indemnities, liability limitations, and intellectual property survive termination.</p>

            <br /><h3 className="text-4xl">14. Limitation of Liability</h3><br />
            <p>To the maximum extent permitted by law, GuardedContent shall not be liable for any indirect, incidental, special, or consequential damages arising from use of the Platform.</p>
            <p className="mt-4">GuardedContent&apos;s total liability for any claim shall not exceed the total amount paid by the User to the Platform in the preceding 12 months.</p>
            <p className="mt-4">Nothing in these Terms excludes rights that cannot be excluded under applicable consumer protection laws, including the Australian Consumer Law.</p>

            <br /><h3 className="text-4xl">15. Indemnification</h3><br />
            <p>You agree to indemnify and hold GuardedContent harmless from any claims, damages, liabilities, or expenses arising from:</p>
            <ul className="list-disc list-inside ml-4 mt-2">
                <li>Your use of the Platform</li>
                <li>Your breach of these Terms</li>
                <li>Your infringement of intellectual property rights</li>
            </ul>
            <p className="mt-4">Content Creators specifically indemnify GuardedContent against claims relating to ownership, licensing, or legality of uploaded Content.</p>

            <br /><h3 className="text-4xl">16. Taxes</h3><br />
            <p>Users acknowledge that applicable taxes (including GST or VAT) may be charged depending on their location.</p>
            <p className="mt-4">Content Creators are responsible for their own tax obligations relating to income earned through the Platform, unless otherwise required by law.</p>

            <br /><h3 className="text-4xl">17. Modifications to the Terms</h3><br />
            <p>GuardedContent may modify these Terms at any time. Updated Terms will be published with a revised effective date.</p>
            <p className="mt-4">Continued use of the Platform after changes constitutes acceptance of the updated Terms.</p>

            <br /><h3 className="text-4xl">18. Governing Law</h3><br />
            <p>These Terms are governed by the laws of New South Wales, Australia.</p>
            <p className="mt-4">Any disputes shall be subject to the exclusive jurisdiction of the courts of New South Wales.</p>

            <br /><h3 className="text-4xl">19. Contact Information</h3><br />
            <p>GuardedContent Pty Ltd (ABN 46 688 024 535)</p>
            <p>Email: <a href="mailto:support@guardedcontent.com" className="text-blue-500">support@guardedcontent.com</a></p>
            <p>Website: <a href="https://guardedcontent.com" className="text-blue-500" target="_blank" rel="noopener noreferrer">https://guardedcontent.com</a></p>

            <br /><h3 className="text-4xl">20. Acknowledgement</h3><br />
            <p>By accessing or using the Platform, you confirm that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
        </div>

        <footer className="px-8 py-8 absolute left-0 bottom-0 right-0">
            © GuardedContent Pty Ltd 2026
        </footer>
    </>
}
